import axios from 'axios';

let prefix = "/hero"

const HeroApi = {
	listHero(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getHeroInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getHeroRef(payload) {
		return axios.get(prefix + "/ref", { params: payload })
	},
	archiveHero(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createHero(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateHero(payload) {
		return axios.post(prefix + "/update", payload)
	},
	selectHeroStat(payload) {
		return axios.post(prefix + "/select-stat", payload)
	},
	selectHeroStarLevel(payload) {
		return axios.post(prefix + "/select-star-level", payload)
	},
}

export default HeroApi;